import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {GlobalDataService} from "../shared-services/global-data.service";

@Injectable({
  providedIn: 'root'
})
export class DataResolverService implements Resolve<any>{

    constructor(private appData: GlobalDataService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        return this.appData.getApplicationData();
    }

}
